import { Type } from '@angular/core';
import { ElectronicsComponent } from '../electronic-supplies/electronics.component';
import { GearOilComponent } from '../gear-oil-component/gear-oil.component';
import { RequestServiceComponent } from '../request-service/request-service.component';

export type SupplyService = Type<RequestServiceComponent | GearOilComponent | ElectronicsComponent>;

export interface SuppliesServicesTab {
    tabTitle: string;
    icon: string;
    urlParam: string;
    component: SupplyService;
    // sort number for the tab, used to determine the order of the tabs in the UI
    index: number;

    // TODO currently the components to be displayed as tab content aren't
    // implemented _> outcomment the following lines if the respective
    // components are available
    // | typeof MaintenanceComponent
    // | typeof MechanicsComponent;
}
export const SUPPLIES_SERVICE_TAB_SEARCH = 'STARTPAGE_SHOW_TAB_*';
export enum TabParamName {
    MECHANICS = 'STARTPAGE_SHOW_TAB_MECHANICS',
    ELECTRONICS = 'STARTPAGE_SHOW_TAB_ELECTRONICS',
    GEAR_OIL = 'STARTPAGE_SHOW_TAB_GEAR_OIL',
    MAINTENANCE = 'STARTPAGE_SHOW_TAB_MAINTENANCE',
    SERVICE = 'STARTPAGE_SHOW_TAB_SERVICE',
}
